import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HeroOverlineProps {
  children: ReactNode;
  className?: string;
  live?: boolean;
  tone?: "gold" | "muted";
}

export function HeroOverline({ children, className, live = false, tone = "gold" }: HeroOverlineProps) {
  const toneClass = tone === "gold" ? "text-[#ffc83d]" : "text-white/50";
  return (
    <div
      className={cn(
        "font-mono text-[10px] uppercase tracking-[0.28em] font-semibold flex items-center gap-2.5",
        toneClass,
        className,
      )}
    >
      {live && (
        <span
          className="w-[7px] h-[7px] rounded-full bg-[#ffc83d] mg-pulse"
          style={{ boxShadow: "0 0 10px #ffc83d" }}
          aria-hidden="true"
        />
      )}
      {children}
    </div>
  );
}
